<template>
    <div class="answer" @click="handleAnswer()">
        <div class="icon">
            <img :src="icon" :alt="answer.icon">
        </div>
        <div class="label">
            {{ answer.answer }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'Answer',
    props: {
        answer: Object
    },
    data () {
        return {
            publicPath: process.env.BASE_URL
        }
    },
    computed: {
        icon () {
            return `${this.publicPath}img/${this.answer.icon}.svg`
        }
    },
    methods: {
        handleAnswer () {
            this.$emit('handleAnswer', this.answer.code)
        }
    }
}
</script>

<style lang="scss" scoped>
    @use '../assets/scss/main.scss' as *;

    .answer {
        width: 100%;
        margin: 0 0 1rem 0;
        text-align: center;
        cursor: pointer;

        @include bp-lg {
            width: 33%;
            margin: 0;
        }

        .icon {
            width: 4rem;
            height: 4rem;
            margin: 1rem auto;
            opacity: 0.8;
            @include transition-out();

            img {
                width: 100%;
                height: 100%;
            }

            @include bp-sm {
                width: 7rem;
                height: 7rem;
                margin: 2rem auto;
            }

            @include bp-lg {
                width: 10rem;
                height: 10rem;
                margin: 2rem auto;
            }
        }

        .label {
            width: 100%;
            margin: 0 auto;
            font-size: 1.25rem;
            text-align: center;
            opacity: 0.8;
            @include transition-out();

            @include bp-lg {
                width: 90%;
                font-size: 2rem;
            }

        }

        &:hover {
            .icon {
                opacity: 1;
                transform: scale(1.1, 1.1);
                @include transition-in();
            }

            .label {
                opacity: 1;
                transform: scale(1.1, 1.1);
                @include transition-in();
            }
        }
    }

</style>
